var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgAutoReplyWarning = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "20px",
    viewBox: "0 -960 960 960",
    width: "20px",
    fill: "#3B3B3B",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m644.54-290.69-34.28-34.16q-6.12-5.76-15.01-5.95-8.89-.2-15.03 5.95-6.14 6.15-6.14 14.86 0 8.7 6.11 15.2l64.85 64.52q8.8 9.04 20.82 9.04t21.37-9.54l64.03-64q5.74-6.1 5.93-14.97.19-8.88-5.96-15.18-6.14-6.12-14.85-6.12t-15.23 6.12l-34.04 34.23v-76.52q0-8.35-6.41-14.71-6.42-6.35-14.97-6.35-8.48 0-14.83 6.45-6.36 6.46-6.36 14.74v76.39Zm-468.62 17.23v-415.31q0-15.65 13.31-24.79 13.31-9.13 28.27-2.71l375.77 151.54q11.34 4.71 14.25 14.03 2.9 9.31-.1 18-3.19 8.96-11.63 13.5-8.44 4.55-20.16-.01L223.88-659.88v116.69l122.47 41q7.73 2.41 12.19 9 4.46 6.6 4.46 12.78 0 6.17-4.46 12.93t-12.19 9.17L223.88-417.4v127.28l182.24-84.65q11-4.77 19.12.7 8.12 5.48 11.23 14.16 3.11 8.68.2 17.05-2.9 8.38-14.18 12.86l-205.68 83.73q-15.21 6.61-28.05-2.46t-12.84-24.73Zm489.64 140.88q-69.33 0-117.75-48.59-48.42-48.6-48.42-117.93 0-69.32 48.59-117.75 48.59-48.42 117.92-48.42t117.75 48.6q48.43 48.59 48.43 117.92T783.48-181q-48.59 48.42-117.92 48.42ZM378.16-478.5Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAutoReplyWarning, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/autoReplyWarning.f9ce12ca.svg";
export { ForwardRef as ReactComponent };